const IS_LIVE = process.env.STORYBOOK_BUILD_ENV === 'live';
const IS_TEST_ENV = process.env.REACT_APP_ENV === 'TEST';

export const VERSION = process.env.REACT_APP_VERSION || '';
export const ENV = process.env.REACT_APP_ENV || 'MOCK';
export const IS_DIMENTION = process.env.IS_DIMENTION !== 'false';

export const SERVICE_WORKER_SCOPE = 'http://localhost:3000/';

export const APP_NAME = process.env.REACT_APP_NAME;

export const RAT_URL = 'https://rat.rakuten.co.jp/';

function getStorybookStaticOrigin() {
	if (IS_TEST_ENV) {
		return 'http://localhost';
	}

	if (IS_LIVE) {
		return process.env.REACT_APP_STORYBOOK_LIVE_URL;
	}

	return `${process.env.REACT_APP_STORYBOOK_URL}/${APP_NAME}/${VERSION}/sb`;
}
export const STORYBOOK_STATIC_ORIGIN = getStorybookStaticOrigin();
export const CUSTOM_HTML_TEMPLATE = 0;
export const BANNER_TEMPLATE = 1;
export const CARD_TEMPLATE = 2;
export const SCREEN = 'WP';
export const SCRIPT_ID = process.env.REACT_APP_SCRIPT_ID || '';

export const API_URL_WEBCX =
	process.env.REACT_APP_API_URL_WEBCX ||
	'https://64375e530c58d3b1456fff2b.mockapi.io';

export const API_URL_EVENT_LOGGER =
	process.env.REACT_APP_API_URL_EVENT_LOGGER ||
	'https://gateway-api.intra.rakuten-it.com/svcobs/api/v1/external/logging/error';

export const API_KEY_EVENT_LOGGER =
	process.env.REACT_APP_API_KEY_EVENT_LOGGER || '';

export const REDIRECT_HOST =
	process.env.REACT_APP_REDIRECT_HOST ||
	'https://stg-cdn.rmc.contents.rakuten.co.jp/sdk/webcx-redirect-module/1.4.0/index.html';

export const STORY_MAIN_FOLDER = 'rest-api';

export const RAT_PROJECT_KEY = 'RMCCX_POPUP';

export const API_URL_CAMPAIGNS_CONFIG =
	process.env.REACT_APP_API_URL_CAMPAIGNS_CONFIG ||
	'https://stg-cdn.rex.contents.rakuten.co.jp';

export const THROTTLE_TIMEOUT = 50;

// NOTE: In case the localstorage schema is changed the storage version should be increased
// NOTE: It's required to avoid issue in case localstorage schema will be updated
// NOTE: The app version can't be used since it will produce to much keys in localstorage
// NOTE: As well it will not allow to keep storage data between FE versions
const LOCALSTORAGE_VERSION = 'STORAGE_1.2.0';

export const LOCAL_STORAGE_KEY = `RMCCX_POPUP_${LOCALSTORAGE_VERSION}`;

export const LOGGER_KEY = 'rmc-web-cx-web-popups';
export const CAMPAIGNS_JSON_FILE_NAME = 'popups';
export const API_MAIN_ENDPOINT = 'popups';
